import { useSidebar } from "../../context/SidebarContext";
import { useEffect, useState } from "react";

const HoverbarContent = ({ nodeData, isInstance }) => {
  if (!nodeData) {
    return "Hover over a node to see details";
  }

  if (isInstance) {
    return (
      <div>
        <strong>Instance Id:</strong>
        <span>{nodeData.id()}</span> <strong>Label:</strong>
        <span>{nodeData.data().label}</span> <strong>Class:</strong>
        <span>{nodeData.data().cls}</span> <strong>Oid:</strong>
        <span>{nodeData.data().oid}</span>
      </div>
    );
  }

  return (
    <div>
      <strong>Class Id:</strong>
      <span>{nodeData.id}</span> <strong>Name:</strong>
      <span>{nodeData.label}</span> <strong>Kind:</strong>
      <span>{nodeData.class_kind}</span>
    </div>
  );
};

export const Hoverbar = ({ nodeData, isInstance }) => {
  const { isExpanded } = useSidebar();
  const [localIsExpanded, setLocalIsExpanded] = useState(isExpanded);

  // Sync local state with context
  useEffect(() => {
    setLocalIsExpanded(!isExpanded);
  }, [isExpanded]);

  // Dynamic hoverbar style
  const hoverbarStyle = {
    position: "fixed",
    bottom: "0px",
    left: localIsExpanded ? "0%" : "22%",
    width: localIsExpanded ? "100%" : "78%",
    background: "#04beb8",
    color: "white",
    textAlign: "center",
    padding: "4px",
    fontSize: "13px",
    zIndex: "-1",
  };

  return (
    <div style={hoverbarStyle}>
      <HoverbarContent nodeData={nodeData} isInstance={isInstance} />
    </div>
  );
};
